export const RESET_PASSWORD_ROUTE = "/ResetPassword";
export const FORGOT_PASSWORD_ROUTE = "/ForgotPassword";

